import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import Auth0BackendLogin from './Auth0BackendLogin';

const CombinedLogin = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: 600, margin: '0 auto', padding: 2 }}>
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Forloop Digishelf Insights
        </Typography>

        <Auth0BackendLogin />
      </Paper>
    </Box>
  );
};

export default CombinedLogin; 